import PropTypes from '../../../_util/vue-types';
import BaseMixin from '../../../_util/BaseMixin';
function noop() {}
function goYear(direction) {
  const next = this.sValue.clone();
  next.add(direction, 'years');
  this.setState({
    sValue: next,
  });
}

function chooseDecade(e, event) {
  const next = this.sValue.clone();
  const quarter = parseInt(e.replace('Q', ''));
  next.quarter(quarter);
  this.__emit('select', next, e);
  event.preventDefault();
}

export default {
  mixins: [BaseMixin],
  props: {
    locale: PropTypes.object,
    value: PropTypes.object,
    defaultValue: PropTypes.object,
    rootPrefixCls: PropTypes.string,
    renderFooter: PropTypes.func,
  },
  data() {
    this.nextCentury = goYear.bind(this, 1);
    this.previousCentury = goYear.bind(this, -1);
    return {
      sValue: this.value || this.defaultValue,
    };
  },
  watch: {
    value(val) {
      this.sValue = val;
    },
  },
  render() {
    const value = this.sValue;
    const { locale, renderFooter } = this.$props;
    const currentQuarter = value.quarter();
    const currentYear = value.year();
    const prefixCls = `${this.rootPrefixCls}-quarter-panel`;
    const decades = ['Q1', 'Q2', 'Q3', 'Q4'];
    const decadesEls = decades.map((row, decadeIndex) => {
      const classNameMap = {
        [`${prefixCls}-cell`]: 1,
        [`${prefixCls}-selected-cell`]: row === `Q${currentQuarter}`,
      };
      let clickHandler = chooseDecade.bind(this, row);
      return (
        <td key={decadeIndex} onClick={clickHandler} role="gridcell" class={classNameMap}>
          <a class={`${prefixCls}-quarter`}>{row}</a>
        </td>
      );
    });

    const footer = renderFooter && renderFooter('quarter');

    return (
      <div class={prefixCls}>
        <div class={`${prefixCls}-header`}>
          <a
            class={`${prefixCls}-prev-century-btn`}
            role="button"
            onClick={this.previousCentury}
            title={locale.previousCentury}
          />

          <div class={`${prefixCls}-century`}>{`${currentYear}${locale.year}`}</div>
          <a
            class={`${prefixCls}-next-century-btn`}
            role="button"
            onClick={this.nextCentury}
            title={locale.nextCentury}
          />
        </div>
        <div class={`${prefixCls}-body`}>
          <table class={`${prefixCls}-table`} cellSpacing="0" role="grid">
            <tbody class={`${prefixCls}-tbody`}>{decadesEls}</tbody>
          </table>
        </div>
        {footer && <div class={`${prefixCls}-footer`}>{footer}</div>}
      </div>
    );
  },
};
